var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperight = function SvgTyperight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.88 2.385 10.62 9.558L11.88 21.5l-1.003-1.115 8.547-7.693H1.38v-1.5h18.045L10.877 3.5l1.004-1.115Z"
  })));
};
export { SvgTyperight as ReactComponent };
export default __webpack_public_path__ + "cff2ec64e8ca60bdece7f2a59cd84289.svg";